import { render, staticRenderFns } from "./van-popup-stockInfo.vue?vue&type=template&id=c035a162&scoped=true"
import script from "./van-popup-stockInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./van-popup-stockInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./van-popup-stockInfo.vue?vue&type=style&index=0&id=c035a162&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c035a162",
  null
  
)

export default component.exports